// extracted by mini-css-extract-plugin
export default {"root":"YDikT5rYLV","logo":"eDhgLGNQvU","header":"NREKpmZKKT","logoDivider":"Vyj3XBzaD3","title":"eAzBPhAIe2","body":"LDAVwFRZgK"};